$(document).ready(function () {
    if ($('.donation-2__carousel').length) {
        $('.donation-2__carousel').slick({
            slidesToShow: 2,
            variableWidth: true,
            slidesToScroll: 1,
            infinite: true,
            speed: 700,
            autoplaySpeed: 7000,
            arrows: false,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    dots: true,
                    arrows: false,
                    variableWidth: false
                }
            },
                {
                    breakpoint: 570,
                    settings: {
                        slidesToShow: 2,
                        dots: true
                    }
                }
            ]
        });
    }
});